<template>
  <div class="flex items-center gap-1">
    <div class="w-2 h-2 rounded-full bubble1" />
    <div class="w-2 h-2 rounded-full bubble2" />
    <div class="w-2 h-2 rounded-full bubble3" />
  </div>
</template>
